import React from 'react'
import { Field } from 'formik'
import SSNField from './fields/SSNField'
import OfferCodeField from './fields/OfferCodeField'
import PhoneField from './fields/PhoneField'
import EmailField from './fields/EmailField'
import ZipcodeField from './fields/ZipcodeField'
import StatesSelectField from './fields/StatesSelectField/StatesSelectField'
import { stringValidator } from './formUtils/stringValidator'
import ConsentCheckboxField from './fields/ConsentCheckboxField'
import states from '../../datasets/states.json'

function FieldComponentRenderer({ field }) {
  const fieldType = field.fieldType.toLowerCase().replace('-', '')
  const { fieldLabel } = field
  const nameField = fieldLabel.toLowerCase().replace(/\s/g, '_')

  const fields = {
    consentcheckbox: (
      <ConsentCheckboxField
        message={field.consentCheckboxMessage}
        nameField={nameField}
        fieldType={fieldType}
        checkboxData={field}
      />
    ),
    email: <Field name={nameField} as={EmailField} validate={stringValidator(field, fieldType)} />,
    phone: <Field name={nameField} as={PhoneField} validate={stringValidator(field, fieldType)} />,
    offercode: (
      <Field name={nameField} as={OfferCodeField} validate={stringValidator(field, fieldType)} />
    ),
    ssn: <Field name={nameField} as={SSNField} validate={stringValidator(field, fieldType)} />,
    statesselect: (
      <StatesSelectField
        states={states}
        nameField={nameField}
        fieldType={fieldType}
        selectData={field}
      />
    ),
    text: <Field name={nameField} validate={stringValidator(field, fieldType)} />,
    zipcode: (
      <Field name={nameField} as={ZipcodeField} validate={stringValidator(field, fieldType)} />
    )
  }
  return fields[fieldType]
}

export default FieldComponentRenderer
